// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TitleRow_row__4oI9g {
  padding: 1rem;
  border-bottom: 1px solid #efefef;
}
.TitleRow_row__4oI9g p {
  color: #666;
}

.TitleRow_title__as7Xa {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Alarms/components/Card/TitleRow.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gCAAA;AACF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,iBAAA;AAAF","sourcesContent":[".row {\n  padding: 1rem;\n  border-bottom: 1px solid #efefef;\n}\n.row p {\n  color: #666;\n}\n\n.title {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `TitleRow_row__4oI9g`,
	"title": `TitleRow_title__as7Xa`
};
export default ___CSS_LOADER_EXPORT___;
